// src/data.js
export const products = [
  {
    id: 'panel_admin',
    nombre: 'Panel Administrativo ⚙️',
    descripcion:
      'El Panel Administrativo proporciona las herramientas para el control preciso y la gestión eficiente de la plataforma.',
    subcategorias: [
      {
        id: 'sistema',
        nombre: 'Sistema',
        articulos: [
          { id: 'admin-crear-clientes',         titulo: 'Admin - Crear Clientes',               enlace: '/general/admin-crear-clientes', fecha: '2025-07-20' },
          { id: 'admin-plano-de-mesa',          titulo: 'Admin - Plano de Mesa',                enlace: '/general/admin-plano-de-mesa', fecha: '2025-07-20' },
          { id: 'admin-roles-ipad',             titulo: 'Admin - Roles de iPad',                 enlace: '/general/admin-roles-ipad', fecha: '2025-07-21' },
          { id: 'admin-roles-administrador',    titulo: 'Admin - Roles de Administrador',       enlace: '/general/admin-roles-administrador', fecha: '2025-07-21' },
          { id: 'admin-usuario-administrativo', titulo: 'Admin - Usuario Administrativo',      enlace: '/general/admin-usuario-administrativo', fecha: '2025-07-22' },
          { id: 'admin-empleados',              titulo: 'Admin - Empleados',                   enlace: '/general/admin-empleados', fecha: '2025-07-22' },
          { id: 'admin-faceid-empleados',       titulo: 'Admin - FaceID para Empleados',       enlace: '/general/admin-faceid-empleados', fecha: '2025-07-22' },
          { id: 'admin-tiempos-comida',         titulo: 'Admin - Tiempos de Comida',           enlace: '/general/admin-tiempos-comida', fecha: '2025-07-22' },
          { id: 'admin-comandas',               titulo: 'Admin - Comandas',                    enlace: '/general/admin-comandas',  fecha: '2025-07-23' }
        ]
      },
    //   {
    //     id: 'reportes',
    //     nombre: 'Reportes',
    //     articulos: [

    //     ]
    //   },
    //   {
    //     id: 'recetas',
    //     nombre: 'Recetas',
    //     articulos: [
         
    //     ]
    //   },
      {
        id: 'menu',
        nombre: 'Menú',
        articulos: [
          { id: 'admin-tipo-orden',  titulo: 'Admin - Tipo de Orden', enlace: '/general/admin-tipo-orden',  fecha: '2025-07-23' }
        ]
      },
      {
        id: 'pagos_contables',
        nombre: 'Pagos Contables',
        articulos: [
          { id: 'admin-abono-a-cuenta-personal-clientes', titulo: 'Admin - Abono a Cuenta Personal Clientes', enlace: '/general/admin-abono-a-cuenta-personal-clientes', fecha: '2025-07-24' },
          { id: 'admin-descuentos',                       titulo: 'Admin - Descuentos',                      enlace: '/general/admin-descuentos', fecha: '2025-07-24' },
          { id: 'admin-tipos-pago',                       titulo: 'Admin - Tipos de Pago',                   enlace: '/general/admin-tipos-pago', fecha: '2025-07-24' },
          { id: 'admin-propinas',                         titulo: 'Admin - Propinas',                        enlace: '/general/admin-propinas', fecha: '2025-07-24' },
          { id: 'admin-impuestos',                        titulo: 'Admin - Impuestos',                       enlace: '/general/admin-impuestos', fecha: '2025-07-24' },
          { id: 'admin-caja-registradora',                titulo: 'Admin - Caja Registradora',              enlace: '/general/admin-caja-registradora',  fecha: '2025-07-24'}
        ]
      },
      {
        id: 'admin-configuracion',
        nombre: 'ADMIN – Configuración',
        articulos: [
          { id: 'config-usuario-administrativo', titulo: 'Configuraciones - Usuario Administrativo', enlace: '/general/config-usuario-administrativo', fecha: '2025-10-19' },
          { id: 'config-roles-administrador', titulo: 'Configuraciones - Roles de Administrador', enlace: '/general/config-roles-administrador', fecha: '2025-10-19' },
          { id: 'config-roles-ipad', titulo: 'Configuraciones - Roles de iPad', enlace: '/general/config-roles-ipad', fecha: '2025-10-19' },
          { id: 'config-tipos-pago', titulo: 'Configuraciones - Tipos de Pago', enlace: '/general/config-tipos-pago', fecha: '2025-10-19' },
          { id: 'config-tiempos-comida', titulo: 'Configuraciones - Tiempos de Comida', enlace: '/general/config-tiempos-comida', fecha: '2025-10-19' },
          { id: 'config-tipo-orden', titulo: 'Configuraciones - Tipo de Orden', enlace: '/general/config-tipo-orden', fecha: '2025-10-19' },
          { id: 'config-propinas', titulo: 'Configuraciones - Propinas', enlace: '/general/config-propinas', fecha: '2025-10-19' },
          { id: 'config-descuentos', titulo: 'Configuraciones - Descuentos', enlace: '/general/config-descuentos', fecha: '2025-10-19' },
          { id: 'config-impuestos', titulo: 'Configuraciones - Impuestos', enlace: '/general/config-impuestos', fecha: '2025-10-19' },
          { id: 'config-creacion-moneda', titulo: 'Configuraciones - Creación Moneda', enlace: '/general/config-creacion-moneda', fecha: '2025-10-19' },
          { id: 'config-zonas', titulo: 'Configuraciones - Zonas', enlace: '/general/config-zonas', fecha: '2025-10-19' },
          { id: 'config-terminales', titulo: 'Configuraciones - Terminales', enlace: '/general/config-terminales', fecha: '2025-10-19' }
        ]
      },
      {
        id: 'admin_otras_configuraciones',
        nombre: 'Admin – Otras Configuraciones',
        articulos: [
          { id: 'configuracion-imagenes-equipos-doble-pantalla', titulo: 'Configuración - Imágenes Equipos Doble Pantalla', enlace: '/general/configuracion-imagenes-equipos-doble-pantalla', fecha: '2025-10-19' },
          { id: 'admin-promociones', titulo: 'Admin - Promociones', enlace: '/general/admin-promociones', fecha: '2025-10-19' },
          { id: 'admin-faceid-empleados', titulo: 'Admin - FaceID para Empleados', enlace: '/general/admin-faceid-empleados', fecha: '2025-10-19' },
          { id: 'admin-comandas', titulo: 'Admin - Comandas', enlace: '/general/admin-comandas', fecha: '2025-10-19' },
          { id: 'admin-caja-registradora', titulo: 'Admin - Caja Registradora', enlace: '/general/admin-caja-registradora', fecha: '2025-10-19' },
          { id: 'admin-plano-mesa', titulo: 'Admin - Plano de Mesa', enlace: '/general/admin-plano-mesa', fecha: '2025-10-19' },
          { id: 'admin-crear-clientes', titulo: 'Admin - Crear Clientes', enlace: '/general/admin-crear-clientes', fecha: '2025-10-19' },
          { id: 'admin-empleados', titulo: 'Admin - Empleados', enlace: '/general/admin-empleados', fecha: '2025-10-19' },
          { id: 'admin-abono-cuenta-personal-clientes', titulo: 'Admin - Abono a Cuenta Personal Clientes', enlace: '/general/admin-abono-cuenta-personal-clientes', fecha: '2025-10-19' }
        ]
      },
      {
        id: 'admin_proveedores',
        nombre: 'Admin – Proveedores',
        articulos: [
          { id: 'requisiciones-solicitar', titulo: 'Requisiciones - Solicitar una Requisición', enlace: '/general/requisiciones-solicitar', fecha: '2025-10-19' },
          { id: 'requisiciones-enviar', titulo: 'Requisiciones - Enviar una Requisición', enlace: '/general/requisiciones-enviar', fecha: '2025-10-19' },
          { id: 'ordenes-compra-crear', titulo: 'Órdenes de Compra - Crear Orden de Compra', enlace: '/general/ordenes-compra-crear', fecha: '2025-10-19' },
          { id: 'proveedores-creacion-interno', titulo: 'Proveedores - Creación de Proveedor Interno', enlace: '/general/proveedores-creacion-interno', fecha: '2025-10-19' },
          { id: 'ordenes-compra-revertir-parcial', titulo: 'Órdenes de Compra - Revertir Parcialmente', enlace: '/general/ordenes-compra-revertir-parcial', fecha: '2025-10-19' },
          { id: 'ordenes-compra-revertir-completa', titulo: 'Órdenes de Compra - Revertir Orden Completa', enlace: '/general/ordenes-compra-revertir-completa', fecha: '2025-10-19' },
          { id: 'ordenes-compra-compra-rapida', titulo: 'Órdenes de Compra - Compra Rápida', enlace: '/general/ordenes-compra-compra-rapida', fecha: '2025-10-19' }
        ]
      },
      // {
      //   id: 'integraciones-clau',
      //   nombre: 'Integraciones – Clau',
      //   articulos: [
      //     { id: 'activar-config-item-clau', titulo: 'Activar Configuración de Ítem para Clau', enlace: '/general/activar-config-item-clau', fecha: '2025-10-19' },
      //     { id: 'activar-config-subcategoria-clau', titulo: 'Activar Configuración de Subcategoría para Clau', enlace: '/general/activar-config-subcategoria-clau', fecha: '2025-10-19' },
      //     { id: 'activar-config-categoria-clau', titulo: 'Activar Configuración de Categoría para Clau', enlace: '/general/activar-config-categoria-clau', fecha: '2025-10-19' }
      //   ]
      // },
      // {
      //   id: 'integraciones-digifact',
      //   nombre: 'Integraciones – Digifact',
      //   articulos: [
      //     { id: 'nota-credito-digifact', titulo: 'Guía rápida para emitir una Nota de Crédito', enlace: '/general/nota-credito-digifact', fecha: '2025-10-19' },
      //     { id: 'facturacion-digifact-panama', titulo: 'Facturación Electrónica - Digifact Panamá', enlace: '/general/facturacion-digifact-panama', fecha: '2025-10-19' }
      //   ]
      // },
      // {
      //   id: 'integraciones-shogo',
      //   nombre: 'Integraciones – Shogo',
      //   articulos: [
      //     { id: 'shogo-conexion-invu', titulo: 'Shogo - Conexión a InvuPOS', enlace: '/general/shogo-conexion-invu', fecha: '2025-10-19' },
      //     { id: 'shogo-conexion-ingles', titulo: 'Shogo - Conexión en Inglés', enlace: '/general/shogo-conexion-ingles', fecha: '2025-10-19' },
      //     { id: 'quickbook-espanol', titulo: 'Conectar Quickbook - Español', enlace: '/general/quickbook-espanol', fecha: '2025-10-19' },
      //     { id: 'quickbook-ingles', titulo: 'Conectar Quickbook - Inglés', enlace: '/general/quickbook-ingles', fecha: '2025-10-19' }
      //   ]
      // },
      // {
      //   id: 'integraciones-siigo',
      //   nombre: 'Integraciones – Siigo',
      //   articulos: [
      //     { id: 'siigo-credenciales', titulo: 'Siigo - Conexión de Credenciales', enlace: '/general/siigo-credenciales', fecha: '2025-10-19' },
      //     { id: 'siigo-mapeo-journals', titulo: 'Siigo - Mapeo de Journals', enlace: '/general/siigo-mapeo-journals', fecha: '2025-10-19' }
      //   ]
      // },
      // {
      //   id: 'integraciones-yappy-hibrido',
      //   nombre: 'Integraciones – Yappy Híbrido',
      //   articulos: [
      //     { id: 'yappy-creacion-grupos', titulo: 'Yappy - Creación de Grupos y Unidades de cobro', enlace: '/general/yappy-creacion-grupos', fecha: '2025-10-19' },
      //     { id: 'yappy-boton-pago', titulo: 'InvuPOS - Creación de Botón de Pago', enlace: '/general/yappy-boton-pago', fecha: '2025-10-19' },
      //     { id: 'yappy-qr', titulo: 'Yappy - Generación de QR', enlace: '/general/yappy-qr', fecha: '2025-10-19' },
      //     { id: 'yappy-credenciales', titulo: 'Yappy - Generación de Credenciales', enlace: '/general/yappy-credenciales', fecha: '2025-10-19' }
      //   ]
      // },
      // {
      //   id: 'app-kds',
      //   nombre: 'Invu POS – App – KDS',
      //   articulos: [
      //     { id: 'kds-agrupacion-flujo', titulo: 'InvuKDS Configuración - Agrupación y Flujo', enlace: '/general/kds-agrupacion-flujo', fecha: '2025-10-19' },
      //     { id: 'kds-pantallas', titulo: 'InvuKDS Configuración - Pantallas', enlace: '/general/kds-pantallas', fecha: '2025-10-19' },
      //     { id: 'kds-estaciones', titulo: 'InvuKDS Configuraciones - Estaciones', enlace: '/general/kds-estaciones', fecha: '2025-10-19' },
      //     { id: 'kds-comandas', titulo: 'InvuKDS - Comandas', enlace: '/general/kds-comandas', fecha: '2025-10-19' },
      //     { id: 'kds-general', titulo: 'InvuKDS Configuraciones - General', enlace: '/general/kds-general', fecha: '2025-10-19' }
      //   ]
      // },      
    ]
  },
  {
    id: 'guias_clau',
    nombre: 'Guías Clau.io 📖',
    descripcion:
      '¿Dudas sobre tu tienda online? Nuestro equipo te guía paso a paso...',
    subcategorias: [
      {
        id: 'basicos',
        nombre: 'Básicos',
        articulos: [
          { id: 'ver-info-cliente-pedidos-clau-anonimo', titulo: 'Ver info del cliente en pedidos de Clau Anónimo', enlace: '/general/ver-info-del-cliente-en-pedidos-de-clau-anonimo',  fecha: '2025-07-24' },
        ]
      },
      {
        id: 'clau-admin',
        nombre: 'Clau Admin',
        articulos: [
          { id: 'funciones-configuracion-clau-admin', titulo: 'Funciones de "Configuración" dentro de Clau Admin', enlace: '/general/funciones-configuracion-clau-admin', fecha: '2025-10-18' },
          { id: 'funciones-pos-clau-admin', titulo: 'Funciones de "POS" dentro de Clau Admin', enlace: '/general/funciones-pos-clau-admin', fecha: '2025-10-18' },
          { id: 'funciones-clientes-clau-admin', titulo: 'Funciones de "Clientes" dentro de Clau Admin', enlace: '/general/funciones-clientes-clau-admin', fecha: '2025-10-18' },
          { id: 'funciones-productos-clau-admin', titulo: 'Funciones de "Productos" dentro de Clau Admin', enlace: '/general/funciones-productos-clau-admin', fecha: '2025-10-18' },
          { id: 'funciones-ordenes-clau-admin', titulo: 'Funciones de "Órdenes" dentro de Clau Admin', enlace: '/general/funciones-ordenes-clau-admin', fecha: '2025-10-18' },
          { id: 'crear-usuarios-clau-admin', titulo: 'Crear usuarios en Clau Admin', enlace: '/general/crear-usuarios-clau-admin', fecha: '2025-10-18' },
          { id: 'canje-regalos-clau-invu', titulo: 'Canje de regalos de Clau.io desde Invu', enlace: '/general/canje-regalos-clau-invu', fecha: '2025-10-18' },
          { id: 'cambiar-status-clau-invu', titulo: 'Cambiar status de Clau.io a través de Invu', enlace: '/general/cambiar-status-clau-invu', fecha: '2025-10-18' },
          { id: 'flujo-orden-clau-invu-pos', titulo: 'Flujo de una orden desde Clau.io a Invu POS', enlace: '/general/flujo-orden-clau-invu-pos', fecha: '2025-10-18' },
          { id: 'canjear-beneficios-clau-invu-pos', titulo: 'Canjear beneficios de Clau.io en Invu POS', enlace: '/general/canjear-beneficios-clau-invu-pos', fecha: '2025-10-18' },
          { id: 'buscar-clientes-registrados-clau-invu', titulo: 'Cómo buscar clientes registrados de Clau en InvuPOS', enlace: '/general/buscar-clientes-registrados-clau-invu', fecha: '2025-10-18' },
          { id: 'solicitar-uber-direct-invu-pos', titulo: 'Solicitar Uber Direct (creando orden desde Invu POS)', enlace: '/general/solicitar-uber-direct-invu-pos', fecha: '2025-10-18' },
          { id: 'solicitar-delivery-uber-direct-ecommerce', titulo: '¿Cómo solicitar delivery de Uber Direct? (orden de ecommerce)', enlace: '/general/solicitar-delivery-uber-direct-ecommerce', fecha: '2025-10-18' },
        ]
      },
      {
        id: 'clau_kiosko',
        nombre: 'Clau-kiosko',
        articulos: [
          { id: 'configuracion-kiosko-app', titulo: 'Configuración de Kiosco | APP', enlace: '/general/configuracion-kiosko-app', fecha: '2025-10-19' },
          { id: 'interfaz-del-kiosko', titulo: 'Interfaz del kiosko', enlace: '/general/interfaz-del-kiosko', fecha: '2025-10-19' },
        ],
      },
      {
        id: 'clau_portales',
        nombre: 'Clau – Portales',
        articulos: [
          { id: 'posibles-modificaciones-portal-clau', titulo: 'Posibles modificaciónes | Portal Clau.io', enlace: '/general/posibles-modificaciones-portal-clau', fecha: '2025-10-19' },
          { id: 'agregar-link-encuesta-email', titulo: 'Agregar link de encuesta en campañas de E-mail', enlace: '/general/agregar-link-encuesta-email', fecha: '2025-10-19' },
          { id: 'crear-plantilla-rapida-email', titulo: 'Crear una plantilla rápida para e-mail', enlace: '/general/crear-plantilla-rapida-email', fecha: '2025-10-19' },
          { id: 'crear-plantilla-editor-email', titulo: 'Crear Plantilla de eMail con el editor - Paso a Paso', enlace: '/general/crear-plantilla-editor-email', fecha: '2025-10-19' },
          { id: 'ver-estadisticas-campanas-email', titulo: 'Ver estadísticas de tus campañas de email.', enlace: '/general/ver-estadisticas-campanas-email', fecha: '2025-10-19' },
          { id: 'enviar-emails-dashboard-clau', titulo: '¿Cómo enviar emails a los usuarios dentro del Dashboard de Clau.io?', enlace: '/general/enviar-emails-dashboard-clau', fecha: '2025-10-19' },
          { id: 'filtrar-clientes-grupo-id', titulo: '¿Cómo filtrar clientes por grupo de ID?', enlace: '/general/filtrar-clientes-grupo-id', fecha: '2025-10-19' },
          { id: 'eliminar-clientes-dashboard-clau', titulo: '¿Cómo eliminar de manera permanente clientes dentro del Dashboard de Clau.io?', enlace: '/general/eliminar-clientes-dashboard-clau', fecha: '2025-10-19' },
          { id: 'enviar-notificacion-apps-dashboard-clau', titulo: 'Enviar notificación para apps desde el Dashboard de Clau.io', enlace: '/general/enviar-notificacion-apps-dashboard-clau', fecha: '2025-10-19' },
          { id: 'invitar-usuarios-passwallet-clau', titulo: '¿Cómo invitar a los usuarios a tener Clau Passwallet Storecard?', enlace: '/general/invitar-usuarios-passwallet-clau', fecha: '2025-10-19' },
          { id: 'asignar-membresia-usuario-clau', titulo: 'Asignar membresía al usuario en el dashboard', enlace: '/general/asignar-membresia-usuario-clau', fecha: '2025-10-19' },
        ],
      },
      {
        id: 'clientes-acciones',
        nombre: 'Clau – Clientes – Acciones masivas e individuales',
        articulos: [
          { id: 'acciones-masivas-clientes', titulo: 'Acciones masivas para clientes', enlace: '/general/acciones-masivas-clientes', fecha: '2025-10-19' },
          { id: 'acciones-individuales-clientes', titulo: 'Acciones individuales para clientes', enlace: '/general/acciones-individuales-clientes', fecha: '2025-10-19' },
          { id: 'filtrar-usuarios-regular', titulo: '¿Cómo filtrar usuarios de manera regular?', enlace: '/general/filtrar-usuarios-regular', fecha: '2025-10-19' },
          { id: 'filtrar-usuarios-grupo', titulo: '¿Cómo filtrar usuarios por grupo?', enlace: '/general/filtrar-usuarios-grupo', fecha: '2025-10-19' },
          { id: 'filtrar-clientes-predefinido', titulo: '¿Cómo filtrar clientes de manera predefinida?', enlace: '/general/filtrar-clientes-predefinido', fecha: '2025-10-19' },
          { id: 'etiquetar-eliminar-etiquetas-clientes', titulo: 'Etiquetar y eliminar etiquetas de clientes dentro del Dashboard de Clau.io', enlace: '/general/etiquetar-eliminar-etiquetas-clientes', fecha: '2025-10-19' },
        ]
      },
      {
        id: 'clientes-masivos',
        nombre: 'Clau – Clientes – Subir y descargar clientes masivo',
        articulos: [
          { id: 'subir-clientes-masivamente', titulo: '¿Cómo subir clientes masivamente?', enlace: '/general/subir-clientes-masivamente', fecha: '2025-10-19' },
          { id: 'descargar-clientes-masivamente', titulo: '¿Cómo descargar clientes masivamente?', enlace: '/general/descargar-clientes-masivamente', fecha: '2025-10-19' },
          { id: 'editar-lealtad-store-card', titulo: 'Editar lealtad store card para Apple y Google Wallet', enlace: '/general/editar-lealtad-store-card', fecha: '2025-10-19' },
          { id: 'editar-gift-card', titulo: 'Editar Gift Card para Google y Apple Wallet', enlace: '/general/editar-gift-card', fecha: '2025-10-19' },
          { id: 'editar-sucursales-clau', titulo: 'Como editar sucursales en Clau', enlace: '/general/editar-sucursales-clau', fecha: '2025-10-19' },
          { id: 'configurar-niveles-lealtad', titulo: 'Configurar niveles de lealtad', enlace: '/general/configurar-niveles-lealtad', fecha: '2025-10-19' },
          { id: 'acumulacion-canje-expiracion-puntos', titulo: 'Acumulación, canje y expiración de puntos', enlace: '/general/acumulacion-canje-expiracion-puntos', fecha: '2025-10-19' },
        ]
      },
      {
        id: 'configuracion-ecommerce',
        nombre: 'Clau – Configuración – Ecommerce',
        articulos: [
          { id: 'configuracion-pedidos-programados', titulo: 'Configuración de pedidos programados', enlace: '/general/configuracion-pedidos-programados', fecha: '2025-10-19' },
          { id: 'opciones-ecommerce-1', titulo: 'Opciones de Ecommerce part. 1', enlace: '/general/opciones-ecommerce-1', fecha: '2025-10-19' },
          { id: 'borrar-productos-ecommerce', titulo: 'Borrar Productos Ecommerce', enlace: '/general/borrar-productos-ecommerce', fecha: '2025-10-19' },
          { id: 'cargar-imagenes-ecommerce', titulo: 'Cargar imágenes Ecommerce', enlace: '/general/cargar-imagenes-ecommerce', fecha: '2025-10-19' },
          { id: 'forma-envio-geofence', titulo: 'Configuración de forma de envío por Geofence', enlace: '/general/forma-envio-geofence', fecha: '2025-10-19' },
          { id: 'metodo-pago-yappy', titulo: 'Método de pago Yappy', enlace: '/general/metodo-pago-yappy', fecha: '2025-10-19' },
          { id: 'metodo-pago-manual-descripcion', titulo: 'Método de pago manual con descripción', enlace: '/general/metodo-pago-manual-descripcion', fecha: '2025-10-19' },
          { id: 'forma-envio-radio-operacion', titulo: 'Configurar forma de envío de radio de operación', enlace: '/general/forma-envio-radio-operacion', fecha: '2025-10-19' },
          { id: 'forma-envio-region', titulo: 'Configurar forma de envío "Entrega por región"', enlace: '/general/forma-envio-region', fecha: '2025-10-19' },
          { id: 'forma-pago-manual-clau', titulo: 'Configurar forma de pago Manual en Clau.io', enlace: '/general/forma-pago-manual-clau', fecha: '2025-10-19' },
          { id: 'subir-terminos-condiciones', titulo: 'Subir términos y condiciones', enlace: '/general/subir-terminos-condiciones', fecha: '2025-10-19' },
          { id: 'configurar-horarios-pedidos', titulo: 'Configurar horarios que se aceptan pedidos', enlace: '/general/configurar-horarios-pedidos', fecha: '2025-10-19' },
          { id: 'configuracion-envio-pickup', titulo: 'Configuración del Método de Envío: Pickup en Clau', enlace: '/general/configuracion-envio-pickup', fecha: '2025-10-19' },
          { id: 'setup-stripe-usa-mex', titulo: 'Set Up Stripe USA / Mex - Payment Method', enlace: '/general/setup-stripe-usa-mex', fecha: '2025-10-19' },
        ]
      },
      {
        id: 'configuracion-parametros-generales',
        nombre: 'Clau – Configuración – Parámetros de configuración generales',
        articulos: [
          { id: 'importar-cambios-invu-multisucursal', titulo: '¿Cómo importar los cambios de INVU automático? - [Multisucursal]', enlace: '/general/importar-cambios-invu-multisucursal', fecha: '2025-10-19'},
          { id: 'importar-cambios-invu', titulo: '¿Cómo importar los cambios de INVU automático?', enlace: '/general/importar-cambios-invu', fecha: '2025-10-19'}
        ]
      },
      {
        id: 'diseno-grafico',
        nombre: 'Clau – Diseño gráfico',
        articulos: [
          { id: 'limitar-categorias-horario', titulo: 'Cómo limitar categorías por horario', enlace: '/general/limitar-categorias-horario', fecha: '2025-10-19' },
          { id: 'editar-colores-ecommerce', titulo: 'Editar colores para el e-commerce', enlace: '/general/editar-colores-ecommerce', fecha: '2025-10-19' },
          { id: 'cambiar-logos-ecommerce', titulo: 'Cambiar logos dentro del e-commerce', enlace: '/general/cambiar-logos-ecommerce', fecha: '2025-10-19' },
          { id: 'cambiar-orden-categorias', titulo: '¿Cómo cambiar el orden de las categorías y subcategorías?', enlace: '/general/cambiar-orden-categorias', fecha: '2025-10-19' },
          { id: 'personalizar-banner-principal', titulo: '¿Cómo personalizar tu banner principal?', enlace: '/general/personalizar-banner-principal', fecha: '2025-10-19' },
        ]
      }, 
      {
        id: 'encuestas',
        nombre: 'Clau – Encuestas',
        articulos: [
          { id: 'crear-encuestas', titulo: 'Cómo crear Encuestas', enlace: '/general/crear-encuestas', fecha: '2025-10-19' },
          { id: 'descargar-respuestas-encuestas', titulo: 'Cómo Descargar las respuestas de las Encuestas', enlace: '/general/descargar-respuestas-encuestas', fecha: '2025-10-19' },
        ]
      },
      {
        id: 'giftcards',
        nombre: 'Clau – Giftcards',
        articulos: [
          { id: 'giftcard-mensuales', titulo: 'Gift card mensuales', enlace: '/general/giftcard-mensuales', fecha: '2025-10-19' },
          { id: 'redimir-giftcards-invu-pos', titulo: 'Redimir Gift cards de Clau.io en Invu POS', enlace: '/general/redimir-giftcards-invu-pos', fecha: '2025-10-19' },
          { id: 'venta-giftcards-automatica', titulo: 'Venta de Gift Cards por tarea automática', enlace: '/general/venta-giftcards-automatica', fecha: '2025-10-19' },
          { id: 'redimir-giftcards-ecommerce', titulo: 'Redimir Gift Cards en el e-commerce de Clau.io', enlace: '/general/redimir-giftcards-ecommerce', fecha: '2025-10-19' },
          { id: 'subir-giftcards-masivo', titulo: 'Subir Gift Cards Manualmente (Masivo)', enlace: '/general/subir-giftcards-masivo', fecha: '2025-10-19' },
          { id: 'subir-giftcards-individual', titulo: 'Subir Gift Cards Manualmente (Individual)', enlace: '/general/subir-giftcards-individual', fecha: '2025-10-19' },
        ]
      },
      {
        id: 'productos',
        nombre: 'Clau – Productos',
        articulos: [
          { id: 'desactivar-productos-clau', titulo: 'Desactivar productos dentro de Clau.io', enlace: '/general/desactivar-productos-clau', fecha: '2025-10-19' },
          { id: 'crear-producto-dashboard-clau', titulo: '¿Cómo crear un producto desde el Dashboard de Clau.io?', enlace: '/general/crear-producto-dashboard-clau', fecha: '2025-10-19' },
          { id: 'filtrar-productos-dashboard-clau', titulo: '¿Cómo filtrar productos desde el Dashboard de Clau.io?', enlace: '/general/filtrar-productos-dashboard-clau', fecha: '2025-10-19' },
        ]
      },     
      {
        id: 'promociones',
        nombre: 'Clau – Promociones',
        articulos: [
          { id: 'herramienta-arreglo-sku', titulo: 'Herramienta para arreglo de SKU', enlace: '/general/herramienta-arreglo-sku', fecha: '2025-10-19' },
          { id: 'beneficio-descuento-categoria', titulo: 'Crear beneficio de descuento en una categoría específica', enlace: '/general/beneficio-descuento-categoria', fecha: '2025-10-19' },
          { id: 'beneficio-free-delivery', titulo: 'Crear beneficio de "Free Delivery"', enlace: '/general/beneficio-free-delivery', fecha: '2025-10-19' },
          { id: 'reportes-beneficios', titulo: 'Ver y descargar reportes de los beneficios', enlace: '/general/reportes-beneficios', fecha: '2025-10-19' },
          { id: 'promo-combos', titulo: 'Crear promo de combos', enlace: '/general/promo-combos', fecha: '2025-10-19' },
          { id: 'beneficio-2x1', titulo: 'Crear un beneficio 2x1', enlace: '/general/beneficio-2x1', fecha: '2025-10-19' },
          { id: 'beneficios-etiquetas', titulo: 'Crear beneficios con etiquetas', enlace: '/general/beneficios-etiquetas', fecha: '2025-10-19' },
        ]
      },
      {
        id: 'promociones-canjes',
        nombre: 'Clau – Promociones – Canjes',
        articulos: [
          { id: 'canjear-beneficios-ecommerce', titulo: 'Canjear beneficios desde el e-commerce', enlace: '/general/canjear-beneficios-ecommerce', fecha: '2025-10-19' },
          { id: 'canjear-regalos-cupones-ecommerce', titulo: 'Cómo canjear regalos/cupones desde el e-commerce', enlace: '/general/canjear-regalos-cupones-ecommerce', fecha: '2025-10-19' },
          { id: 'canjear-codigos-promocionales-ecommerce', titulo: 'Cómo canjear códigos promocionales desde el e-commerce', enlace: '/general/canjear-codigos-promocionales-ecommerce', fecha: '2025-10-19' },
        ]
      },
      {
        id: 'promociones-regalos',
        nombre: 'Clau – Promociones – Regalos',
        articulos: [
          { id: 'regalo-punch-cards', titulo: 'Crear regalo de Punch Cards', enlace: '/general/regalo-punch-cards', fecha: '2025-10-19' },
          { id: 'estadisticas-canje-regalos', titulo: 'Cómo descargar estadísticas de canje en los regalos', enlace: '/general/estadisticas-canje-regalos', fecha: '2025-10-19' },
          { id: 'regalo-tienda-puntos', titulo: 'Crear regalo para tienda de puntos', enlace: '/general/regalo-tienda-puntos', fecha: '2025-10-19' },
          { id: 'codigos-promocionales', titulo: 'Crear códigos promocionales', enlace: '/general/codigos-promocionales', fecha: '2025-10-19' },
          { id: 'regalo-bienvenida', titulo: 'Crear regalo de bienvenida', enlace: '/general/regalo-bienvenida', fecha: '2025-10-19' },
          { id: 'regalo-cumpleanos', titulo: 'Crear regalo de cumpleaños', enlace: '/general/regalo-cumpleanos', fecha: '2025-10-19' },
        ]
      },
      {
        id: 'dashboard-reportes',
        nombre: 'Clau – Dashboard – Reportes',
        articulos: [
          { id: 'reporte-inventario', titulo: 'Reporte de inventario dentro de Clau', enlace: '/general/reporte-inventario', fecha: '2025-10-19' },
          { id: 'reportes-giftcards', titulo: 'Reportes de gift cards', enlace: '/general/reportes-giftcards', fecha: '2025-10-19' },
          { id: 'reportes-personalizados', titulo: 'Reportes personalizados', enlace: '/general/reportes-personalizados', fecha: '2025-10-19' },
          { id: 'reportes-contables-ecommerce', titulo: 'Reportes contables de ecommerce', enlace: '/general/reportes-contables-ecommerce', fecha: '2025-10-19' },
          { id: 'reportes-info-compra', titulo: 'Reportes de información de compra', enlace: '/general/reportes-info-compra', fecha: '2025-10-19' },
          { id: 'reportes-info-lealtad', titulo: 'Reportes de información de lealtad', enlace: '/general/reportes-info-lealtad', fecha: '2025-10-19' },
          { id: 'reportes-info-productos', titulo: 'Reportes de información de productos', enlace: '/general/reportes-info-productos', fecha: '2025-10-19' },
          { id: 'reporte-ventas-cliente', titulo: 'Reporte de Ventas por Cliente', enlace: '/general/reporte-ventas-cliente', fecha: '2025-10-19' },
        ]
      },      
    ]
  },
  {
    id: 'facturacion_electronica',
    nombre: 'Facturación Electrónica 🧾',
    descripcion:
      'Guías prácticas paso a paso para configurar y gestionar la facturación electrónica en Invu POS de forma ágil, segura y sin complicaciones',
    subcategorias: [
      {
        id: 'basicos',
        nombre: 'Básicos',
        articulos: [
          // { id: 'digifact-descarga-reporte', titulo: 'Pasos para descargar el reporte en la plataforma de Digifact', enlace: '/general/digifact-descarga-reporte', country: 'El Salvador', fecha: '2025-07-24' },
          { id: 'cliente-extranjero-el-salvador', titulo: 'Creación de un Cliente Extranjero - El Salvador', enlace: '/general/cliente-extranjero-el-salvador', country: 'El Salvador', fecha: '2025-07-24' },
          { id: 'cliente-juridico-el-salvador', titulo: 'Creación de un Cliente Juridico - El Salvador', enlace: '/general/cliente-juridico-el-salvador', country: 'El Salvador', fecha: '2025-07-24' },
          { id: 'cliente-natural-el-salvador', titulo: 'Creación de un Cliente Natural - El Salvador', enlace: '/general/cliente-natural-el-salvador', country: 'El Salvador', fecha: '2025-07-24' },
          { id: 'cliente-natural-guatemala', titulo: 'Creación de un Cliente Natural - Guatemala', enlace: '/general/cliente-natural-guatemala', country: 'Guatemala', fecha: '2025-07-24' },
        ]
      },
    ]
  },
  {
    id: 'invu_pos',
    nombre: 'Aplicación Invu POS 📱',
    descripcion:
      'Cumple con la normativa de tu país y factura de forma rápida y segura.',
    subcategorias: [
      {
        id: 'inventario',
        nombre: 'Inventario',
        articulos: [
          { id: 'inventario-recetas', titulo: 'Inventario - Recetas', enlace: '/general/inventario-recetas', fecha: '2025-07-23' },
          { id: 'inventario-mermas', titulo: 'Inventario - Mermas', enlace: '/general/inventario-mermas', fecha: '2025-07-23' },
          { id: 'inventario-tipos-mermas', titulo: 'Inventario - Tipos de Mermas', enlace: '/general/inventario-tipos-mermas', fecha: '2025-07-23' },
          { id: 'inventario-conteo-inventario', titulo: 'Inventario - Conteo de Inventario', enlace: '/general/inventario-conteo-inventario', fecha: '2025-07-23' },
          { id: 'inventario-receta-opciones-modificadores', titulo: 'Inventario - Receta a Opciones de Modificadores', enlace: '/general/inventario-receta-opciones-modificadores', fecha: '2025-07-23' },
          { id: 'inventario-ajuste-subreceta', titulo: 'Inventario - Ajuste de Subreceta', enlace: '/general/inventario-ajuste-subreceta', fecha: '2025-07-23' },
          { id: 'inventario-ajuste-inventario', titulo: 'Inventario - Ajuste de Inventario', enlace: '/general/inventario-ajuste-inventario', fecha: '2025-07-23' },
          { id: 'inventario-subrecetas', titulo: 'Inventario - Subrecetas', enlace: '/general/inventario-subrecetas', fecha: '2025-07-23' },
          { id: 'inventario-ingredientes', titulo: 'Inventario - Ingredientes', enlace: '/general/inventario-ingredientes', fecha: '2025-07-23' },
          { id: 'inventario-categoria-producto', titulo: 'Inventario - Categoría de Producto', enlace: '/general/inventario-categoria-producto', fecha: '2025-07-23' }
        ]
      },
      {
        id: 'menu',
        nombre: 'Menú',
        articulos: [
          { id: 'menu-promociones', titulo: 'Menú Promociones', enlace: '/general/menu-promociones', fecha: '2025-07-23' },
          { id: 'menu-comisiones', titulo: 'Menú Comisiones', enlace: '/general/menu-comisiones', fecha: '2025-07-23' },
          { id: 'menu-categoria', titulo: 'Menú Categoría', enlace: '/general/menu-categoria', fecha: '2025-07-23' },
          { id: 'menu-modificadores-opciones', titulo: 'Menú Modificadores Opciones', enlace: '/general/menu-modificadores-opciones', fecha: '2025-07-23' },
          { id: 'menu-items', titulo: 'Menú Ítems', enlace: '/general/menu-items', fecha: '2025-07-23' },
          { id: 'menu-subcategorias', titulo: 'Menú Subcategorías', enlace: '/general/menu-subcategorias', fecha: '2025-07-23' },
          { id: 'menu-modificadores-precios-multiples', titulo: 'Menú - Modificadores Precios Múltiples', enlace: '/general/menu-modificadores-precios-multiples', fecha: '2025-07-23' },
          { id: 'menu-item-precios-multiples', titulo: 'Menú - Ítem Precios Múltiples', enlace: '/general/menu-item-precios-multiples', fecha: '2025-07-23' }
        ]
      },
      {
        id: 'ordenacion-elementos',
        nombre: 'Ordenación de Elementos',
        articulos: [
          { id: 'orden-de-subcategorias', titulo: 'Orden de Subcategorías', enlace: '/general/orden-de-subcategorias', fecha: '2025-07-23' },
          { id: 'orden-opciones-modificadores', titulo: 'Orden de Opciones de Modificadores', enlace: '/general/orden-opciones-modificadores', fecha: '2025-07-23' },
          { id: 'orden-categorias', titulo: 'Orden de Categorías', enlace: '/general/orden-categorias', fecha: '2025-07-23' },
          { id: 'orden-menu', titulo: 'Orden de Menú', enlace: '/general/orden-menu', fecha: '2025-07-23' },
          { id: 'orden-modificadores', titulo: 'Orden de Modificadores', enlace: '/general/orden-modificadores', fecha: '2025-07-23' }
        ]
      },
      {
        id: 'invukds',
        nombre: 'InvuKDS',
        articulos: [
          { id: 'invukds-configuracion-pantallas', titulo: 'InvuKDS Configuración Pantallas', enlace: '/general/invukds-configuracion-pantallas', fecha: '2025-07-24' },
          { id: 'invukds-configuracion-estaciones', titulo: 'InvuKDS Configuración Estaciones', enlace: '/general/invukds-configuracion-estaciones', fecha: '2025-07-24' },
          { id: 'invukds-configuración-agrupacion-y-flujo', titulo: 'InvuKDS Configuración Agrupación y Flujo', enlace: '/general/invukds-configuracion-agrupacion-y-flujo', fecha: '2025-07-24' },
          { id: 'invukds-comandas', titulo: 'InvuKDS Comandas', enlace: '/general/invukds-comandas', fecha: '2025-07-24' },
          { id: 'invukds-configuraciones-general', titulo: 'InvuKDS Configuraciones General', enlace: '/general/invukds-configuraciones-general', fecha: '2025-07-24' }
        ]
      },
      {
        id: 'ordenes-de-compra',
        nombre: 'Órdenes de Compra',
        articulos: [
          { id: 'ordenes-de-compra-crear-orden-de-compra', titulo: 'Órdenes de Compra - Crear Orden de Compra', enlace: '/general/ordenes-de-compra-crear-orden-de-compra', fecha: '2025-07-24' },
          { id: 'ordenes-compra-revertir-parcialmente', titulo: 'Órdenes de Compra - Revertir Parcialmente', enlace: '/general/ordenes-compra-revertir-parcialmente', fecha: '2025-07-24' },
          { id: 'ordenes-compra-revertir-orden-completa', titulo: 'Órdenes de Compra - Revertir Orden Completa', enlace: '/general/ordenes-compra-revertir-orden-completa', fecha: '2025-07-24' },
          { id: 'ordenes-compra-compra-rapida', titulo: 'Órdenes de Compra - Compra Rápida', enlace: '/general/ordenes-compra-compra-rapida', fecha: '2025-07-24' }
        ]
      },
      {
        id: 'proveedores',
        nombre: 'Proveedores',
        articulos: [
          { id: 'proveedores-producto-por-proveedor', titulo: 'Proveedores - Producto por Proveedor', enlace: '/general/proveedores-producto-por-proveedor', fecha: '2025-07-24' },
          { id: 'proveedores-creacion-proveedor-interno', titulo: 'Proveedores - Creación de Proveedor Interno', enlace: '/general/proveedores-creacion-proveedor-interno', fecha: '2025-07-24' },
          { id: 'proveedores-gestionar-proveedores', titulo: 'Proveedores - Gestionar Proveedores', enlace: '/general/proveedores-gestionar-proveedores', fecha: '2025-07-24' }
        ]
      },
      {
        id: 'requisiciones',
        nombre: 'Requisiciones',
        articulos: [
          { id: 'requisiciones-solicitar-una-requisicion', titulo: 'Requisiciones - Solicitar una Requisición', enlace: '/general/requisiciones-solicitar-una-requisicion', fecha: '2025-07-24' },
          { id: 'requisiciones-enviar-una-requisicion', titulo: 'Requisiciones - Enviar una Requisición', enlace: '/general/requisiciones-enviar-una-requisicion', fecha: '2025-07-24' }
        ]
      },
      {
        id: 'invupos',
        nombre: 'InvuPOS',
        articulos: [
          { id: 'invupos-pagos-automaticos', titulo: 'InvuPOS Pagos Automáticos', enlace: '/general/invupos-pagos-automaticos', fecha: '2025-07-24' },
          { id: 'invupos-reimpresion-ordenes', titulo: 'InvuPOS - Reimpresión de Órdenes No Facturadas', enlace: '/general/invupos-reimpresion-ordenes', fecha: '2025-07-24' }
        ]
      }
    ]
  },
  {
    id: 'release_notes',
    nombre: 'Release Notes 📝',
    descripcion:
      'Encuentra aquí manuales, demos y guías paso a paso para que tu experiencia con Invu POS sea siempre fluida, rápida y sin complicaciones.',
      subcategorias: [
        {
          id: 'invu_pos_3',
          nombre: 'Invu POS 3',
          img: 'https://img.invupos.com/webinvu/Software%20release/Products/Invu%20POS%203.png',
          hover: 'bg-[#E0F7FA]',
          articulos: [
            {
              id: 'abril_actualizaciones_de_producto2025',
              titulo: 'Abril - Actualizaciones de Producto',
              enlace: '/software-release/invupos3/abril2025-actualizaciones-de-producto',
              fecha: '2025-07-20'
            }
          ]
        },
        {
          id: 'admin',
          nombre: 'ADMIN',
          img: 'https://img.invupos.com/webinvu/Software%20release/Products/ADMINv1.png',
          hover: 'bg-[#F3E5F5]',
          articulos: [
            {
              id: 'abril_actualizaciones_de_admin2025',
              titulo: 'Abril - Actualizaciones de Admin',
              area: 'General',
              enlace: '/software-release/admin/abril2025-actualizaciones-de-admin',
              fecha: '2025-07-21'
            },
            {
              id: 'abril_nuevos_reportes_agregados2025',
              titulo: 'Abril - Nuevos reportes agregados',
              area: 'Reportes',
              enlace: '/software-release/admin/abril2025-nuevos-reportes-agregados',
              fecha: '2025-07-22'
            }
          ]
        },
        {
          id: 'kds',
          nombre: 'Invu KDS',
          img: 'https://img.invupos.com/webinvu/Software%20release/Products/Invu%20KDS.png',
          hover: 'bg-[#FFF3E0]',
          articulos: []
        },
        {
          id: 'supply',
          nombre: 'Invu Supply',
          img: 'https://img.invupos.com/webinvu/Software%20release/Products/Invu%20Supply.png',
          hover: 'bg-[#E8F5E9]',
          articulos: []
        },
        {
          id: 'report',
          nombre: 'Invu Report',
          img: 'https://img.invupos.com/webinvu/Software%20release/Products/Invu%20Report.png',
          hover: 'bg-[#FFEBEE]',
          articulos: []
        }
      ]
  },
  {
    id: 'integraciones_manuales',
    nombre: 'Integraciones 🔗',
    descripcion: 'Conectamos tu sistema con deliverys, bancos, e-commerce y más, sin complicaciones.',
    subcategorias: [
      {
        id: 'integraciones-clau',
        nombre: 'Clau',
        articulos: [
          { id: 'activar-config-item-clau', titulo: 'Activar Configuración de Ítem para Clau', enlace: '/general/activar-config-item-clau', fecha: '2025-10-19' },
          { id: 'activar-config-subcategoria-clau', titulo: 'Activar Configuración de Subcategoría para Clau', enlace: '/general/activar-config-subcategoria-clau', fecha: '2025-10-19' },
          { id: 'activar-config-categoria-clau', titulo: 'Activar Configuración de Categoría para Clau', enlace: '/general/activar-config-categoria-clau', fecha: '2025-10-19' }
        ]
      },
      {
        id: 'integraciones-digifact',
        nombre: 'Digifact',
        articulos: [
          { id: 'nota-credito-digifact', titulo: 'Guía rápida para emitir una Nota de Crédito', enlace: '/general/nota-credito-digifact', fecha: '2025-10-19' },
          { id: 'facturacion-digifact-panama', titulo: 'Facturación Electrónica - Digifact Panamá', enlace: '/general/facturacion-digifact-panama', fecha: '2025-10-19' }
        ]
      },
      {
        id: 'integraciones-shogo',
        nombre: 'Shogo',
        articulos: [
          { id: 'shogo-conexion-invu', titulo: 'Shogo - Conexión a InvuPOS', enlace: '/general/shogo-conexion-invu', fecha: '2025-10-19' },
          { id: 'shogo-conexion-ingles', titulo: 'Shogo - Conexión en Inglés', enlace: '/general/shogo-conexion-ingles', fecha: '2025-10-19' },
          { id: 'quickbook-espanol', titulo: 'Conectar Quickbook - Español', enlace: '/general/quickbook-espanol', fecha: '2025-10-19' },
          { id: 'quickbook-ingles', titulo: 'Conectar Quickbook - Inglés', enlace: '/general/quickbook-ingles', fecha: '2025-10-19' }
        ]
      },
      {
        id: 'integraciones-siigo',
        nombre: 'Siigo',
        articulos: [
          { id: 'siigo-credenciales', titulo: 'Siigo - Conexión de Credenciales', enlace: '/general/siigo-credenciales', fecha: '2025-10-19' },
          { id: 'siigo-mapeo-journals', titulo: 'Siigo - Mapeo de Journals', enlace: '/general/siigo-mapeo-journals', fecha: '2025-10-19' }
        ]
      },
      {
        id: 'integraciones-yappy-hibrido',
        nombre: 'Yappy Híbrido',
        articulos: [
          { id: 'yappy-creacion-grupos', titulo: 'Yappy - Creación de Grupos y Unidades de cobro', enlace: '/general/yappy-creacion-grupos', fecha: '2025-10-19' },
          { id: 'yappy-boton-pago', titulo: 'InvuPOS - Creación de Botón de Pago', enlace: '/general/yappy-boton-pago', fecha: '2025-10-19' },
          { id: 'yappy-qr', titulo: 'Yappy - Generación de QR', enlace: '/general/yappy-qr', fecha: '2025-10-19' },
          { id: 'yappy-credenciales', titulo: 'Yappy - Generación de Credenciales', enlace: '/general/yappy-credenciales', fecha: '2025-10-19' }
        ]
      },
      {
        id: 'app-kds',
        nombre: 'Invu POS – App – KDS',
        articulos: [
          { id: 'kds-agrupacion-flujo', titulo: 'InvuKDS Configuración - Agrupación y Flujo', enlace: '/general/kds-agrupacion-flujo', fecha: '2025-10-19' },
          { id: 'kds-pantallas', titulo: 'InvuKDS Configuración - Pantallas', enlace: '/general/kds-pantallas', fecha: '2025-10-19' },
          { id: 'kds-estaciones', titulo: 'InvuKDS Configuraciones - Estaciones', enlace: '/general/kds-estaciones', fecha: '2025-10-19' },
          { id: 'kds-comandas', titulo: 'InvuKDS - Comandas', enlace: '/general/kds-comandas', fecha: '2025-10-19' },
          { id: 'kds-general', titulo: 'InvuKDS Configuraciones - General', enlace: '/general/kds-general', fecha: '2025-10-19' }
        ]
      },      
      {
        id: 'yappy',
        nombre: 'Yappy',
        articulos: [
          { id: 'creacion-grupos-unidades-cobro', titulo: 'Yappy - Creación de Grupos y Unidades de cobro', enlace: '/yappy/creacion-de-grupos-y-unidades-de-cobro',  fecha: '2025-07-20'  },
          { id: 'creacion-boton-pago-yappy', titulo: 'Yappy - Creación de Botón de Pago Yappy', enlace: '/yappy/creacion-de-boton-de-pago-de-yappy',   fecha: '2025-07-20'  },
          { id: 'generacion-credenciales-yappy', titulo: 'Yappy - Generación de Credenciales', enlace: '/yappy/generacion-de-credenciales',   fecha: '2025-07-21'  },
          { id: 'generacion-qr-yappy', titulo: 'Yappy - Generación de QR', enlace: '/yappy/generacion-de-qr',   fecha: '2025-07-22' }
        ]
      },
      {
        id: 'deliverect',
        nombre: 'Deliverect',
        articulos: [
          { id: 'tipo-de-orden', titulo: 'Deliverect - Tipo de Orden', enlace: '/deliverect/tipo-de-orden',  fecha: '2025-07-22' },
          { id: 'configuracion-item', titulo: 'Deliverect - Configuración de Ítem', enlace: '/deliverect/configuracion-de-item',  fecha: '2025-07-22' },
          { id: 'creacion-tipo-pago-deliverect', titulo: 'Deliverect - Creación de Tipo de Pago', enlace: '/deliverect/creacion-de-tipo-de-pago',  fecha: '2025-07-22' },
          { id: 'activacion-caja-pedidos', titulo: 'Deliverect - Activación de Caja para Pedidos', enlace: '/deliverect/activacion-de-caja-para-pedidos',  fecha: '2025-07-22' }
        ]
      },
      {
        id: 'cloudbeds',
        nombre: 'Cloudbeds',
        articulos: [
          { id: 'cloudbeds-conexion-invu', titulo: 'Cloudbeds - Conexión de Integración con InvuPOS', enlace: '/cloudbeds/cloudbeds-conexion-invu', fecha: '2025-11-07' },
          { id: 'tipo-de-pago-cloudbeds', titulo: 'Cloudbeds - Tipo de Pago', enlace: '/cloudbeds/tipo-de-pago',  fecha: '2025-11-07' },
          { id: 'tipo-de-orden-cloudbeds', titulo: 'Cloudbeds - Tipo de Orden', enlace: '/cloudbeds/tipo-de-orden',  fecha: '2025-11-07' },
          { id: 'cloudbeds-cargo-habitacion', titulo: 'Cloudbeds - Cargo a la Habitación desde InvuPOS', enlace: '/cloudbeds/cloudbeds-cargo-habitacion', fecha: '2025-11-07' },
          { id: 'cloudbeds-revision-cargo', titulo: 'Cloudbeds - Revisión de Cargo a la Cuenta', enlace: '/cloudbeds/cloudbeds-revision-cargo', fecha: '2025-11-07' }
        ]
      },
      {
        id: 'marketman',
        nombre: 'Marketman',
        articulos: [
          { id: 'conexion-cuenta-marketman', titulo: 'MarketMan - Conexión de Cuenta', enlace: '/marketman/conexion-de-cuenta',  fecha: '2025-07-24' }
        ]
      }
    ]
  }
]

// Hook de búsqueda — sin cambios
export const allArticulos = products.flatMap(prod =>
  prod.subcategorias.flatMap(cat =>
    cat.articulos.map(a => ({
      ...a,
      producto: prod.nombre,
      subcategoria: cat.nombre
    }))
  )
)
